import React from 'react';
import { Box } from '@mui/material';
import { motion, useMotionValue, useSpring, useTransform, useReducedMotion } from 'framer-motion';

/**
 * 3D döntés egérmozgásra (asztali gépen). Telefonon és csökkentett mozgásnál
 * nem csinál semmit, a tartalom ilyenkor simán jelenik meg.
 */
type Tilt3DProps = {
  children: React.ReactNode;
  max?: number; // maximális döntés fokban
  sx?: any;
};

const Tilt3D: React.FC<Tilt3DProps> = ({ children, max = 10, sx }) => {
  const reduce = useReducedMotion();
  const x = useMotionValue(0);
  const y = useMotionValue(0);
  const rotateX = useSpring(useTransform(y, [-0.5, 0.5], [max, -max]), { stiffness: 200, damping: 18 });
  const rotateY = useSpring(useTransform(x, [-0.5, 0.5], [-max, max]), { stiffness: 200, damping: 18 });

  const onMove = (e: React.PointerEvent<HTMLDivElement>) => {
    if (reduce || e.pointerType === 'touch') return;
    const r = e.currentTarget.getBoundingClientRect();
    x.set((e.clientX - r.left) / r.width - 0.5);
    y.set((e.clientY - r.top) / r.height - 0.5);
  };
  const onLeave = () => {
    x.set(0);
    y.set(0);
  };

  return (
    <Box sx={{ perspective: '900px', ...sx }}>
      <motion.div
        onPointerMove={onMove}
        onPointerLeave={onLeave}
        style={{ rotateX, rotateY, transformStyle: 'preserve-3d', height: '100%' }}
      >
        {children}
      </motion.div>
    </Box>
  );
};

export default Tilt3D;